import { photoSrc } from "@/lib/format";
import { FileText } from "lucide-react";

const isImage = (u = "") => /\.(png|jpe?g|webp|gif|heic|heif)$/i.test(u.split("?")[0]);

export default function InvoiceThumb({ url, label = "Bekijk", size = 40, testid }) {
  if (!url) return <span className="text-xs text-slate-400">—</span>;
  const src = photoSrc(url);
  const open = () => window.open(src, "_blank");
  return (
    <button
      type="button"
      onClick={open}
      data-testid={testid}
      title={`${label} — klik om te openen`}
      className="group inline-flex items-center gap-2"
    >
      <span
        className="relative overflow-hidden rounded-md border border-slate-200 bg-slate-50 flex items-center justify-center transition-all group-hover:border-blue-400 group-hover:shadow-md"
        style={{ width: size, height: size }}
      >
        {isImage(url) ? (
          <img src={src} alt="Kopie-factuur" className="h-full w-full object-cover transition-transform group-hover:scale-110" />
        ) : (
          <span className="flex flex-col items-center justify-center text-[8px] font-semibold text-red-500 leading-none">
            <FileText className="h-4 w-4 mb-0.5" /> PDF
          </span>
        )}
      </span>
      <span className="text-sm text-blue-700 group-hover:underline">{label}</span>
    </button>
  );
}
